import store from '../../store';
import { api } from '../../../lib/axios/api';
import { GET_SIGHT } from '../../types';

export const getSight = (id) =>
	api
		.get(`/sights/${id}`)
		.then((res) => store.dispatch({ type: GET_SIGHT, payload: res.data }));
